// Generated by Melange

import * as Buhta_cabinet__Button from "../../html/Button.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(taxName) {
  return function (taxPrice) {
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                className: "text-asphalt-dark mb-1",
                                children: taxName
                              }),
                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                className: "text-success font-semibold",
                                children: taxPrice
                              })
                        ],
                        className: "flex flex-col gap-1"
                      }),
                  JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsxs(Buhta_cabinet__Button.make, {
                              size: "s",
                              kind: "default",
                              className: "flex items-center gap-1.5 border border-gray-main rounded-md pl-2 pr-3 py-1.5",
                              children: [
                                JsxRuntime.jsx("img", {
                                      alt: "buhta-cashier",
                                      src: StaticAsset.src("/static/icons/cashier-green-16.svg")
                                    }),
                                JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                      className: "font-semibold",
                                      children: "Квитанция"
                                    })
                              ]
                            })
                      })
                ],
                className: "flex justify-between gap-3 items-center"
              });
  };
}

function HrmEmployeeTaxes$Tax(Props) {
  return make(Props.taxName)(Props.taxPrice);
}

const Tax = {
  make: HrmEmployeeTaxes$Tax
};

function HrmEmployeeTaxes(Props) {
  const match = React.useState(function () {
        return false;
      });
  const setIsVisible = match[1];
  const isVisible = match[0];
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                          className: "!font-mediumbold",
                                          children: "Май 2023"
                                        }),
                                    JsxRuntime.jsx("button", {
                                          children: isVisible ? JsxRuntime.jsx("img", {
                                                  className: "w-5 h-5",
                                                  alt: "more",
                                                  src: StaticAsset.src("/static/icons/arrow-up.svg")
                                                }) : null
                                        })
                                  ],
                                  className: "flex items-center justify-between px-6"
                                }),
                            isVisible ? JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                    className: "text-asphalt-dark",
                                                    children: "Зарплата на руки"
                                                  }),
                                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                    children: "100 000 ₸"
                                                  })
                                            ],
                                            className: "flex justify-between px-6"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                    className: "text-asphalt-dark",
                                                    children: "Зарплата с налогами"
                                                  }),
                                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                    children: "100 000 ₸"
                                                  })
                                            ],
                                            className: "flex justify-between px-6"
                                          }),
                                      JsxRuntime.jsx("hr", {
                                            className: "mt-4 text-divider"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(HrmEmployeeTaxes$Tax, {
                                                    taxName: "Обязательные пенсионные взносы",
                                                    taxPrice: "10 000 ₸"
                                                  }),
                                              JsxRuntime.jsx(HrmEmployeeTaxes$Tax, {
                                                    taxName: "Взносы на обязательное социальное медицинское страхование",
                                                    taxPrice: "2 000 ₸"
                                                  }),
                                              JsxRuntime.jsx(HrmEmployeeTaxes$Tax, {
                                                    taxName: "Индивидуальный подоходный налог",
                                                    taxPrice: "3 970 ₸"
                                                  }),
                                              JsxRuntime.jsx(HrmEmployeeTaxes$Tax, {
                                                    taxName: "Социальные отчисления",
                                                    taxPrice: "3 000 ₸"
                                                  }),
                                              JsxRuntime.jsx(HrmEmployeeTaxes$Tax, {
                                                    taxName: "Обязательные пенсионные взносы работодателя",
                                                    taxPrice: "1 275 ₸"
                                                  }),
                                              JsxRuntime.jsx(HrmEmployeeTaxes$Tax, {
                                                    taxName: "Отчисления на соц. мед. страхование",
                                                    taxPrice: "1 275 ₸"
                                                  })
                                            ],
                                            className: "flex flex-col gap-3 py-4 px-6"
                                          }),
                                      JsxRuntime.jsx("hr", {
                                            className: "text-divider"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                    className: "text-asphalt-dark !font-mediumbold",
                                                    children: "Итого за налоги"
                                                  }),
                                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                    className: "!font-mediumbold",
                                                    children: "22 520 ₸"
                                                  })
                                            ],
                                            className: "flex justify-between mt-3 px-6"
                                          })
                                    ],
                                    className: "flex flex-col gap-1 mt-3"
                                  }) : JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                            className: "text-gray-medium",
                                                            children: "Зарплата"
                                                          }),
                                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                            className: "font-mediumbold",
                                                            children: "85 000 ₸"
                                                          })
                                                    ],
                                                    className: "flex gap-2"
                                                  }),
                                              JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                            className: "text-gray-medium",
                                                            children: "К оплате"
                                                          }),
                                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                            className: "font-mediumbold",
                                                            children: "18 700 ₸"
                                                          })
                                                    ],
                                                    className: "flex gap-2"
                                                  })
                                            ],
                                            className: "flex flex-col"
                                          }),
                                      JsxRuntime.jsx("button", {
                                            children: JsxRuntime.jsx("img", {
                                                  className: "w-5 h-5",
                                                  alt: "more",
                                                  src: StaticAsset.src("/static/icons/arrow-down-gray.svg")
                                                }),
                                            onClick: (function (param) {
                                                Curry._1(setIsVisible, (function (prevState) {
                                                        return !prevState;
                                                      }));
                                              })
                                          })
                                    ],
                                    className: "flex items-start justify-between mt-3 px-6"
                                  })
                          ],
                          className: "flex flex-col gap-1 "
                        }),
                    className: "border border-gray-main rounded-md py-4 hover:bg-gray-pale cursor-pointer",
                    onClick: (function (param) {
                        Curry._1(setIsVisible, (function (prevState) {
                                return !prevState;
                              }));
                      })
                  }),
              className: "w-[758px] mt-6"
            });
}

const make$1 = HrmEmployeeTaxes;

export {
  Tax ,
  make$1 as make,
}
/* Buhta_cabinet__Button Not a pure module */
